import React from 'react';
import {
    MenuItem,
    TextField,
    Grid,
    Chip,
  } from "@mui/material";

function GridPlanaltina({handler}, {edificio}) {
  return (
    <div>
        <Grid item xs={3}>
            <TextField
              label="Edifício"
              variant="outlined"
              value={edificio}
              style={{ minWidth: 130, maxWidth: 150 }}
              select
              onChange={handler}
              SelectProps={{
                multiple: false,
                renderValue: (selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <Chip key={selected} label={selected} style={{ margin: 2 }} />
                  </div>
                ),
              }}
            >
                <MenuItem value={'FUP ALOJ. ED. CAMPO'}>FUP ALOJ. ED. CAMPO</MenuItem>
<MenuItem value={'FUP GUARITA'}>FUP GUARITA</MenuItem>
<MenuItem value={'FUP MESP'}>FUP MESP</MenuItem>
<MenuItem value={'FUP SUBEST'}>FUP SUBEST</MenuItem>
<MenuItem value={'FUP SUBST'}>FUP SUBST</MenuItem>
<MenuItem value={'FUP UAC'}>FUP UAC</MenuItem>
<MenuItem value={'FUP UEP'}>FUP UEP</MenuItem>


            </TextField>
          </Grid>

    </div>
  )
}

export default GridPlanaltina